import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 156.73 83.36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 156.73 83.36\" id=\"arrow\">\n    <defs>\n        <style>\n            #arrow .cls-1 {\n                fill: none;\n                stroke-linecap: round;\n                stroke-linejoin: round;\n                stroke-width: 10px;\n            }\n        </style>\n    </defs>\n    <polyline class=\"cls-1\" points=\"151.73 5 78.36 78.36 5 5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol